import { PagingParams } from 'modules/types/PagingParams';

export const pagingToParams = (params: PagingParams) => {
  const urlParams = new URLSearchParams();

  if (params.page) {
    urlParams.append('page', `${params.page - 1}`);
  }

  if (params.size) {
    urlParams.append('size', `${params.size}`);
  }

  if (params.search) {
    urlParams.append('search', params.search);
  }

  params.sort
    ?.map((s) => `${s.column},${s.sort}`)
    .forEach((entry) => {
      urlParams.append('sort', entry);
    });

  return urlParams;
};
